import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Calculators from "@/pages/Calculators";
import Sites from "@/pages/Sites";
import SiteDetail from "@/pages/SiteDetail";
import Quotes from "@/pages/Quotes";
import QuoteEditor from "@/pages/QuoteEditor";
import Crm from "@/pages/Crm";
import Suppliers from "@/pages/Suppliers";
import Subcontractors from "@/pages/Subcontractors";
import Equipment from "@/pages/Equipment";
import Risks from "@/pages/Risks";
import MapPage from "@/pages/MapPage";
import Assistant from "@/pages/Assistant";
import Sources from "@/pages/Sources";
import Tasks from "@/pages/Tasks";
import DevenirPrestataire from "@/pages/DevenirPrestataire";
import Simulator from "@/pages/Simulator";
import Info from "@/pages/Info";

function Protected({ children }) {
  const { user } = useApp();
  const location = useLocation();
  if (user === undefined) return <div className="min-h-screen bg-teca-900 flex items-center justify-center text-amber-500 font-display text-2xl font-bold uppercase">TECA BUILD 360…</div>;
  if (user === null) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/devenir-prestataire" element={<DevenirPrestataire />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/calculs" element={<Calculators />} />
            <Route path="/chantiers" element={<Sites />} />
            <Route path="/chantiers/:id" element={<SiteDetail />} />
            <Route path="/devis" element={<Quotes />} />
            <Route path="/devis/:id" element={<QuoteEditor />} />
            <Route path="/simulateur" element={<Simulator />} />
            <Route path="/crm" element={<Crm />} />
            <Route path="/fournisseurs" element={<Suppliers />} />
            <Route path="/sous-traitants" element={<Subcontractors />} />
            <Route path="/materiel" element={<Equipment />} />
            <Route path="/carte" element={<MapPage />} />
            <Route path="/risques" element={<Risks />} />
            <Route path="/taches" element={<Tasks />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/infos" element={<Info />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
